export default "https://cdn-static.gokick.com/assets/a922e5568f1cf4039f8565ae5776ec3d05b76040/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";